export default {"src":"/_next/static/media/RG.9b7aa314.svg","height":512,"width":340,"blurWidth":0,"blurHeight":0};